import React, { useCallback } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { AssessmentSetStyles, WrapList, WrapDroppable, WrapDragIcon, AssessmentName, WrapSectionList, WrapDraggable } from './Style'
import { map } from 'lodash';
import { CustomSection, XSSpaceBetween } from 'styles/GlobalStyle';
import { DragIndicator } from '@mui/icons-material';
import { Button, IconButtons } from 'components/Form';
import { createAssessmentsHooks } from '.';
import { visibleTypes } from 'keys';
import AllocationParams from './AllocationParams'

const CreateSet = (props) => {
    const { createAssessments, isPractice, showBattery, setSelectedAssessmentDefs, selectedAssessmentDefs } = props

    const layoutTypeBtns = createAssessmentsHooks.useLayoutTypeBtns()
    // const createAssessmentsBtn = createAssessmentsHooks.useBatteryAllocationBtn()

    const handleLayout = useCallback((val, index) => {
        let nSelectedAssessmentDefs = [...selectedAssessmentDefs]
        nSelectedAssessmentDefs[index] = { ...nSelectedAssessmentDefs[index], layoutType: val }
        setSelectedAssessmentDefs(nSelectedAssessmentDefs)
    }, [selectedAssessmentDefs])

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        let items = Array.from(selectedAssessmentDefs);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setSelectedAssessmentDefs(items)
    }

    const allocationBtn = {
        id: 1,
        color: "secondary",
        label: "הקצאה",
        loading: createAssessments?.isPending,
        action: createAssessments?.action,
        disabledColor: "secondary",
        width: '150px'
    };


    return (
        <AssessmentSetStyles>
            <div className='header-set'>
                <div className='title'>
                    {isPractice ? "V להוספת תרגולים לביצוע" : "V להוספת מבדקים לסוללה"}
                </div>
            </div>
            <WrapSectionList>
                <CustomSection $bg $grow $flex $border>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <WrapDroppable droppableId="characters">
                            {(provided) => (
                                <WrapList className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                                    {selectedAssessmentDefs && map(selectedAssessmentDefs)?.map(({ id, name, layoutType, layoutTypeDef, visible_type }, index) => {
                                        return (
                                            <WrapDraggable key={id.toString()} draggableId={id.toString()} index={index}>
                                                {(provided) => (
                                                    <CustomSection $flex justify="space-between" align="center" height={50} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <div className='drag-and-name'>
                                                            <WrapDragIcon>
                                                                <DragIndicator fontSize='small' color="dark" />
                                                            </WrapDragIcon>
                                                            <AssessmentName>
                                                                {name}
                                                            </AssessmentName>
                                                        </div>
                                                        <XSSpaceBetween />
                                                        {
                                                            visible_type === visibleTypes.WORD_GROUP &&
                                                            <IconButtons
                                                                btns={layoutTypeBtns}
                                                                setSelected={(e, val) => handleLayout(val, index)}
                                                                selected={layoutType || layoutTypeDef}
                                                            />
                                                        }
                                                    </CustomSection>
                                                )}
                                            </WrapDraggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </WrapList>
                            )}
                        </WrapDroppable>
                    </DragDropContext>
                </CustomSection>
            </WrapSectionList>
            <div className='footer'>
                {isPractice || <AllocationParams />}
                <div className='create-assessment-btn'>
                    <Button  {...allocationBtn} />
                </div>
            </div>
        </AssessmentSetStyles>
    );
}

export default CreateSet;
